import { render, staticRenderFns } from "./InternalLBAssignedVmTab.vue?vue&type=template&id=5fc40aba&scoped=true&"
import script from "./InternalLBAssignedVmTab.vue?vue&type=script&lang=js&"
export * from "./InternalLBAssignedVmTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc40aba",
  null
  
)

export default component.exports